// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.accordion__section {
    overflow: hidden;
    flex-shrink: 0;
}

/* Header */

.accordion__header {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    height: 40px;
    padding: 0 9px;
    background: none;
    border: none;
    border-bottom: 1px solid var(--color-border);
    color: var(--color-text-muted);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    text-align: left;
    cursor: pointer;
    user-select: none;
    flex-shrink: 0;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .accordion__header:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.accordion__section.active .accordion__header {
    color: var(--color-text);
}

/* Edit mode — header gets an accent left border */

.accordion__header--editing {
    border-left: 3px solid var(--color-accent);
    padding-left: 6px;
}

/* headerSlot — grows to fill space between title and controls */

.accordion__header_slot {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

/* Controls — extra elements rendered right-aligned in the header */

.accordion__controls {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 4px;
}

/* Chevron — rotates when section is open */

.accordion__chevron {
    display: inline-block;
    font-size: 15px;
    line-height: 1;
    color: var(--color-text-muted);
    transform: rotate(0deg);
    transition: transform 0.15s;
}

.accordion__section.active .accordion__chevron {
    transform: rotate(90deg);
    color: var(--color-text);
}

/* Content — height/width set via inline style; transition gives the slide */

.accordion__content {
    overflow: hidden;
    pointer-events: none;
}

.accordion--animating .accordion__content {
    transition: height 0.07s ease, width 0.07s ease;
}

.accordion__section.active .accordion__content {
    overflow: auto;
    pointer-events: auto;
}

/* ============================================================
   Horizontal variant — sections flow left-to-right,
   headers are vertical strips on the left of each section
   ============================================================ */

.accordion--horizontal {
    flex-direction: row;
}

.accordion--horizontal .accordion__section {
    display: flex;
}

.accordion--horizontal .accordion__header {
    writing-mode: vertical-lr;
    width: 40px;
    height: 100%;
    padding: 9px 0;
    border-bottom: none;
    border-right: 1px solid var(--color-border);
    justify-content: flex-end;
}

.accordion--horizontal .accordion__chevron {
    display: none;
}

.accordion--horizontal .accordion__content {
    height: 100%;
}

.accordion--horizontal .accordion__controls {
    order: -1;
    margin-left: 0;
    margin-bottom: auto;
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/Accordion/s.accordion.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,4CAA4C;IAC5C,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,kDAAkD;;AAElD;IACI,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA,gEAAgE;;AAEhE;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,mEAAmE;;AAEnE;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,2CAA2C;;AAE3C;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA,4EAA4E;;AAE5E;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;;;iEAGiE;;AAEjE;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,mBAAmB;AACvB","sourcesContent":[".accordion {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n\n.accordion__section {\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n/* Header */\n\n.accordion__header {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    width: 100%;\n    height: 40px;\n    padding: 0 9px;\n    background: none;\n    border: none;\n    border-bottom: 1px solid var(--color-border);\n    color: var(--color-text-muted);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    text-align: left;\n    cursor: pointer;\n    user-select: none;\n    flex-shrink: 0;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .accordion__header:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.accordion__section.active .accordion__header {\n    color: var(--color-text);\n}\n\n/* Edit mode — header gets an accent left border */\n\n.accordion__header--editing {\n    border-left: 3px solid var(--color-accent);\n    padding-left: 6px;\n}\n\n/* headerSlot — grows to fill space between title and controls */\n\n.accordion__header_slot {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n/* Controls — extra elements rendered right-aligned in the header */\n\n.accordion__controls {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n/* Chevron — rotates when section is open */\n\n.accordion__chevron {\n    display: inline-block;\n    font-size: 15px;\n    line-height: 1;\n    color: var(--color-text-muted);\n    transform: rotate(0deg);\n    transition: transform 0.15s;\n}\n\n.accordion__section.active .accordion__chevron {\n    transform: rotate(90deg);\n    color: var(--color-text);\n}\n\n/* Content — height/width set via inline style; transition gives the slide */\n\n.accordion__content {\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.accordion--animating .accordion__content {\n    transition: height 0.07s ease, width 0.07s ease;\n}\n\n.accordion__section.active .accordion__content {\n    overflow: auto;\n    pointer-events: auto;\n}\n\n/* ============================================================\n   Horizontal variant — sections flow left-to-right,\n   headers are vertical strips on the left of each section\n   ============================================================ */\n\n.accordion--horizontal {\n    flex-direction: row;\n}\n\n.accordion--horizontal .accordion__section {\n    display: flex;\n}\n\n.accordion--horizontal .accordion__header {\n    writing-mode: vertical-lr;\n    width: 40px;\n    height: 100%;\n    padding: 9px 0;\n    border-bottom: none;\n    border-right: 1px solid var(--color-border);\n    justify-content: flex-end;\n}\n\n.accordion--horizontal .accordion__chevron {\n    display: none;\n}\n\n.accordion--horizontal .accordion__content {\n    height: 100%;\n}\n\n.accordion--horizontal .accordion__controls {\n    order: -1;\n    margin-left: 0;\n    margin-bottom: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
